import styled from 'styled-components';

export const StyledLayout = styled.div`
  ${({ $offset }: { $offset: number }) => `--headerOffset: ${$offset}px`};
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  /* Reason for using min-width - https://leonardofaria.net/2020/07/18/using-flexbox-and-text-ellipsis-together */
  min-width: 0;
  display: flex;
  flex-direction: column;

  .header {
    > div {
      position: inherit;
    }
  }
  .shell-layout-learner-content {
    display: flex;
    flex: 1;
    min-width: 0;
  }
`;
